export default __webpack_public_path__ + "static/media/trainingIcon.2b41f938.svg";